import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import StatusCard from '../components/StatusCard';
import OnlineBadge from '../components/OnlineBadge';
import Blocked from './Blocked';
import { useTagResolve } from './useTagResolve';
import { useSession } from '../auth/session';

export default function TagResolve() {
  const { code = '' } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const session = useSession();
  const st = useTagResolve(code, sp.get('k'));

  if (st.loading) {
    return (
      <div className="app">
        <div className="spinner" />
        <p className="center muted">Reading tag {code}…</p>
      </div>
    );
  }

  if (st.error || !st.data) {
    return (
      <div className="app pad center">
        <OnlineBadge />
        <div style={{ fontSize: 44, margin: '8px 0' }}>⚠️</div>
        <h1>Tag not usable</h1>
        <p className="error">{st.error}</p>
        <p className="muted tiny">Tag code: <strong>{code}</strong>{st.rawError ? ` · ${st.rawError}` : ''}</p>
        <button className="secondary" onClick={() => nav('/')}>Back</button>
      </div>
    );
  }

  const d = st.data;

  if (d.schedule.status === 'BLOCKED') {
    return <Blocked schedule={d.schedule} equipmentName={d.equipment.name} onBack={() => nav('/')} />;
  }

  const goToForm = () => {
    const target = `/t/${encodeURIComponent(code)}/form${sp.get('k') ? `?k=${sp.get('k')}` : ''}`;
    if (!session) nav('/signin', { state: { from: target } });
    else nav(target);
  };

  return (
    <div className="app">
      <OnlineBadge />
      {st.offline && <span className="pill info" style={{ marginBottom: 4 }}>Offline — saved equipment list</span>}
      {st.provisional && !st.offline && <span className="pill info" style={{ marginBottom: 4 }}>Checking latest…</span>}
      <StatusCard equipment={d.equipment} schedule={d.schedule} lastReading={d.lastReading} />
      <button onClick={goToForm}>Enter readings</button>
      <button className="secondary" onClick={() => nav('/')}>Cancel</button>
    </div>
  );
}
